import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight, TrendingUp, ShieldCheck, GraduationCap, Users } from 'lucide-react';
import { fadeUp, staggerParent, viewportOnce } from './motionPresets';

const BENEFITS = [
  { icon: TrendingUp, label: 'More opportunities' },
  { icon: ShieldCheck, label: 'More support' },
  { icon: GraduationCap, label: 'More knowledge' },
  { icon: Users, label: 'More growth' },
];

export default function BecomeAgentCTA() {
  return (
    <section className="relative overflow-hidden bg-[#071533] text-white" data-testid="become-cta-section">
      <div className="absolute inset-0 bg-gradient-to-br from-[#071533] via-[#0f2a5e] to-[#1a3a7a]" />
      <div className="absolute -top-24 right-10 w-[30rem] h-[30rem] rounded-full bg-[#b8862d]/15 blur-[120px] pointer-events-none" />
      <div className="absolute inset-0 opacity-[0.10] pointer-events-none" aria-hidden="true">
        <svg viewBox="0 0 800 300" className="w-full h-full" preserveAspectRatio="xMidYMid slice">
          {[60, 140, 220, 300, 380, 470, 560, 650].map((x, i) => (
            <rect key={i} x={x} y={300 - (40 + i * 26)} width="30" height={40 + i * 26} rx="3" fill="#60a5fa" />
          ))}
          <path d="M55,250 C200,210 300,140 430,110 S650,40 760,15" stroke="#f5c876" strokeWidth="3.5" fill="none" opacity="0.6" />
        </svg>
      </div>

      <motion.div
        className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-28 text-center"
        variants={staggerParent}
        initial="hidden"
        whileInView="show"
        viewport={viewportOnce}
      >
        <motion.span variants={fadeUp} className="text-xs font-semibold uppercase tracking-widest text-[#f5c876]">Your next chapter starts here</motion.span>
        <motion.h2 variants={fadeUp} className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight">
          Ready to grow with a team invested in your success?
        </motion.h2>
        <motion.p variants={fadeUp} className="mt-5 text-lg text-slate-300 leading-relaxed max-w-2xl mx-auto">
          Join KR and get the support, training, technology, and carrier opportunities you need to build a stronger,
          more rewarding insurance business.
        </motion.p>

        <motion.ul variants={fadeUp} className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-3">
          {BENEFITS.map((b) => (
            <li key={b.label} className="inline-flex items-center gap-2 text-sm text-slate-200">
              <b.icon size={16} className="text-[#f5c876]" /> {b.label}
            </li>
          ))}
        </motion.ul>

        <motion.div variants={fadeUp} className="mt-10">
          <Link
            to="/become-an-agent"
            data-testid="become-cta"
            className="group inline-flex items-center gap-2 px-8 py-4 rounded-full bg-[#b8862d] text-white font-semibold text-lg shadow-[0_12px_36px_-10px_rgba(184,134,45,0.7)] hover:bg-[#a67520] hover:-translate-y-0.5 transition-all duration-300"
          >
            Become an Agent
            <ArrowRight size={19} className="group-hover:translate-x-1 transition-transform" />
          </Link>
        </motion.div>
      </motion.div>
    </section>
  );
}
